iScreenWizard.controller('FeedbackUitnodigingController', function ($rootScope, $scope, $state, $mdDialog, Dictionary, ErrorHandler, userService, Mailtemplate, nieuwe360FeedbackService, WizardFeedback) {

    $scope.userService = userService;
    $scope.feedback = nieuwe360FeedbackService.model;
    $scope.mailtemplates = [];
    $scope.trixInitializeMailtemplateTags = $rootScope.trixInitializeMailtemplateTags;
    $scope.sending = false;

    $scope.$on('$stateChangeSuccess', function (event, toState) {
        $scope.refresh();
    });

    $scope.refresh = function() {
        if (!$scope.feedback.afzender) {
            $scope.feedback.afzender = userService.model.email;
        }

        params = {};
        if ($scope.feedback.brontestafname.opleidingsniveau_id > 0 && $scope.feedback.rapporttemplate_id > 0) {
            params.testafname_rapporttemplate_id = $scope.feedback.rapporttemplate_id;
            params.testafname_opleidingsniveau_id = $scope.feedback.brontestafname.opleidingsniveau_id;
        }
        Mailtemplate.all(params).then(function(mailtemplates) {
            $scope.mailtemplates = mailtemplates;
            if (mailtemplates.length > 0) {
                $scope.selecteerMailtemplate(mailtemplates[0]);
            }
        });
    };

    $scope.selecteerMailtemplate = function(mailtemplate) {
        $scope.feedback.onderwerp = mailtemplate.onderwerp;
        $scope.feedback.inhoud = mailtemplate.inhoudhtml || mailtemplate.inhoudtext;
    };

    $scope.storeFeedback = function() {
        $scope.sending = true;
        WizardFeedback.store($scope.feedback).then(function(response) {
            if (ErrorHandler.hasErrors(response)) {
                ErrorHandler.showDialog(response);
            } else {
                nieuwe360FeedbackService.model = {};
                nieuwe360FeedbackService.model.wizardfeedbackrapporttype = $scope.feedback.wizardfeedbackrapporttype;
                nieuwe360FeedbackService.SaveState();
                $state.go('360-feedback/feedback-overzicht').then(function() {
                    if ($scope.feedback.feedbackgevers.length < 2) {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title(Dictionary.translate('app.invitation_send', true))
                                .ariaLabel(Dictionary.translate('app.invitation_send', true))
                                .ok(Dictionary.translate('app.okay', true))
                        );
                    } else {
                        $mdDialog.show(
                            $mdDialog.alert()
                                .clickOutsideToClose(true)
                                .title(Dictionary.translate('app.invitations_send', true))
                                .ariaLabel(Dictionary.translate('app.invitations_send', true))
                                .ok(Dictionary.translate('app.okay', true))
                        );
                    }
                });
            }
        });
    };

});